import { z } from 'zod';
import { zObject } from '../util/zod';

export type Rights = {
    create: boolean;
    read: boolean;
    publish: boolean;
    administrate: boolean;
    update: boolean;
    delete: boolean;
    comment: boolean;
    member: boolean;
};
export const rightsSchema = zObject<Rights>({
    create: z.boolean(),
    read: z.boolean(),
    publish: z.boolean(),
    administrate: z.boolean(),
    update: z.boolean(),
    delete: z.boolean(),
    comment: z.boolean(),
    member: z.boolean(),
});
export const validateIsFormatRights = (object: object): object is Rights => rightsSchema.safeParse(object).success;
